module.exports = __webpack_public_path__ + "f25285cf44b6ac2e96c6262fe5c7efa1.svg";